const MuiListOverrides = {
  MuiList: {
    styleOverrides: {
      root: () => ({
        padding: 0
      })
    }
  }
};

export { MuiListOverrides };
